<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>运单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="运单号" prop="freight_bill_code">
                <el-input v-model.trim="searchform.freight_bill_code" style="width:100%" clearable
                  placeholder="请输入运单号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="product_code">
                <el-select v-model="searchform.product_code" placeholder="请输入产品名称模糊匹配或者下拉选择" style="width:100%"
                  :remote-method="getproductlist" filterable remote :loading="productloading" :disabled="show">
                  <el-option v-for="item in productlist" :key="item.product_code" :label="item.product"
                    :value="item.product_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库单号" prop="out_bill_code">
                <el-input v-model.trim="searchform.out_bill_code" style="width:100%" clearable placeholder="请输入出库单号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户名称" prop="dealer_name">
                <el-input v-model.trim="searchform.dealer_name" style="width:100%" clearable placeholder="请输入客户名称" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库日期" prop="datelist">
                <el-date-picker style="width:100%" v-model="searchform.datelist" type="daterange"
                  value-format="timestamp" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="datelist1">
                <el-date-picker style="width:100%" v-model="searchform.datelist1" type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="仓库编码" prop="from_warehouse_code">
                <el-input v-model.trim="searchform.from_warehouse_code" style="width:100%" clearable
                  placeholder="请输入仓库编码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发货状态" prop="searchform">
                <el-select v-model="searchform.status" placeholder="请选择发货状态">
                  <el-option label="未发货" :value="0"></el-option>
                  <el-option label="已发货" :value="1"></el-option>
                  <el-option label="已签收" :value="2"></el-option>
                  <el-option label="已下载" :value="3"></el-option>
                  <el-option label="扫码中" :value="4"></el-option>
                  <el-option label="已取消" :value="5"></el-option>
                  <el-option label="已确认数量" :value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['freight_select']">搜索
              </el-button>
              <el-button v-permission="['freight_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button>
              <el-button v-permission="['freight_add']" type="primary" @click="clickDownloadExcel()">下载导入模板</el-button>
              <el-button v-permission="['freight_add']" type="primary" @click="clickImportExcel()">导入</el-button>
              <el-button v-permission="['freight_add']" type="primary" @click="addorder()">新增出库单</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br id="A1" />
      <!-- 新增修改模块       -->
      <Freight-Add :search="search" ref="editorder" />
      <ExportList ref="myExportList" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>运单管理</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :highlight-current-row='true'
            @current-change="handleCurrentChange" :data="tableData" style="width:100%;" id="parent">
            <el-table-column prop="freight_bill_code" label="运单号" width="190" show-overflow-tooltip />
            <el-table-column prop="out_bill_code" label="出库单号" min-width="160" show-overflow-tooltip />
            <el-table-column prop="out_bill_time" label="出库时间" min-width="150" show-overflow-tooltip />
            <el-table-column prop="from_warehouse_code" label="发货仓库编码" min-width="100" show-overflow-tooltip />
            <el-table-column prop="from_warehouse" label="发货仓库" min-width="120" show-overflow-tooltip />
            <el-table-column prop="dealer_code" label="客户编码" min-width="120" show-overflow-tooltip />
            <el-table-column prop="dealer_name" label="客户名称" min-width="120" show-overflow-tooltip />
            <el-table-column prop="address" label="客户地址" min-width="200" show-overflow-tooltip />
            <el-table-column prop="product_code" label="产品编码" min-width="130" show-overflow-tooltip />
            <el-table-column prop="product_name" label="产品名称" min-width="150" show-overflow-tooltip />
            <el-table-column prop="batch_no" label="批次" min-width="120" show-overflow-tooltip />
            <el-table-column prop="unit_name" label="单位" min-width="100" show-overflow-tooltip />
            <el-table-column prop="plan_quantity" label="计划出库数量" min-width="100" show-overflow-tooltip />
            <el-table-column prop="confirm_quantity" label="出库人工确认数量" min-width="120" show-overflow-tooltip />
            <el-table-column prop="qty2" label="扫码数量" min-width="100" show-overflow-tooltip />
            <el-table-column prop="status" label="发货状态" min-width="100" />
            <!-- <el-table-column prop="extension_field1" label="类型" min-width="80" /> -->
            <el-table-column prop="extension_field2" label="备注" min-width="200" show-overflow-tooltip />
            <el-table-column label="操作" min-width="280" fixed="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button type="primary" icon="el-icon-edit" v-permission="['freight_update']"
                    @click="getoutbilldata(props.row.out_bill_code)">
                  </el-button>
                  <el-button type="danger" icon="el-icon-delete" v-permission="['freight_delete']"
                    @click="deletedate(props.row.out_bill_code)"></el-button>
                  <el-button type="primary" v-permission="['freight_finish']"
                    @click="updateoutstatus(props.row.out_bill_code)">出库</el-button>
                  <el-button type="primary" v-permission="['freight_export']"
                    @click="toExportList(props.row)">导出</el-button>
                  <el-button type="primary" v-permission="['freight_export']"
                    @click="handlePrinter(props.row)">打印</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>

      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>产品批次表</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" ref="singleTable" :data="productData"
            style="width:100%;"> <el-table-column prop="outBillCode" label="出库单号" min-width="100"
              show-overflow-tooltip></el-table-column>

            <el-table-column prop="productCode" label="产品编码" width="200" show-overflow-tooltip />
            <el-table-column prop="productName" label="产品名称" min-width="150" show-overflow-tooltip />
            <el-table-column prop="batchNo" label="批次" min-width="120" show-overflow-tooltip />
            <el-table-column prop="planBatch" label="计划批次" min-width="120" show-overflow-tooltip />
            <el-table-column prop="planBatchQuantity" label="计划出库数量" min-width="120" show-overflow-tooltip />
            <el-table-column prop="scanBatchQuantity" label="扫码出库数量" min-width="120" show-overflow-tooltip />
            <el-table-column prop="actualBatchQuantity" label="实际出库数量" min-width="120" show-overflow-tooltip />
            <el-table-column prop="createTime" label="创建时间" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column prop="sendStatus" label="状态" min-width="100" show-overflow-tooltip>
            </el-table-column>
           -->
          </el-table>
          <br />
          <el-pagination background layout="total,prev, pager, next, jumper, sizes" :total="productPageTotal"
            :page-sizes="[10, 20, 50, 100]" :page-size.sync="productSearchForm.pageSize"
            :current-page.sync="productSearchForm.pageIndex" @size-change="handleProductSizeChange"
            @current-change="handleProductCurrentChange" />
        </el-col>
      </el-row>

      <!-- 导入   -->
      <el-dialog title="导入出库单" :visible.sync="importExcel.dialogVisible">
        <el-form>
          <el-form-item>
            <el-upload class="upload-demo" :action="importExcel.uploadURL" :on-success="handleSuccess"
              :on-error="handleError" :before-upload="beforeUpload" :limit="100" :show-file-list=false
              list-type="xls/xlsx">
              <el-button size="small" type="primary" v-loading="importExcel.loading">点击选择文件上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500MB</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-dialog>
      <print ref="print"></print>
    </div>
  </div>
</template>
<script>
import {
  selectoutbillorder,
  donloadoutbillorder,
  deleteoutbillorder,
  updateoutstatus,
  outbillorderproductsbatchlist,
} from "@/api/physical";
import { downloadoutbill } from "@/api/plant";
import { productlist } from "@/api/base";
import { departtree } from "@/api/orgin";
import FreightAdd from "./components/FreightAdd";
import ExportList from "./components/exportList";
import print from "./components/print";
//引入导出组件模块
export default {
  name: "freight",
  components: { FreightAdd, ExportList, print },
  mounted() {
    //请求部门列表数据并且便利到表格
    // this.Tabledata();
    // var timestamp = (new Date()).valueOf();
    // this.$set(this.searchform, 'datelist', [timestamp - (86400000 * 7), timestamp]);
    this.open();
    this.getdeparttree();
    this.getproductlist();
  },
  data() {
    return {
      //基础数据
      departtree: [],
      listLoading: false,
      productData: [],
      tableData: [],
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        batch_no: null,
        out_bill_code: null,
        dealer_name: null,
        freight_bill_code: null,
        datelist: null,
        datelist1: null,
        sout_bill_date: null,
        eout_bill_date: null,
        from_warehouse_code: null,
        dealer_code: null,
        product_code: null,
        currPage: 1,
        pageSize: 10
      },
      //产品列表下拉
      productloading: false,
      show: false,
      productlist: [],
      productSearchForm: {
        "batchNo": "",
        "outBillCode": "",
        "productCode": "",
        "productName": "",
        "pageIndex": 1,
        "pageSize": 10,
      },
      productPageTotal: 0,
      importExcel: {
        dialogVisible: false,
        loading: false,
        uploadURL: process.env.VUE_APP_BASE_API + "/api/out/order/importOutBillOrder"
      },
    };
  },
  methods: {
    toExportList(row) {
      this.$refs.myExportList.row = Object.assign({}, row);
      this.$refs.myExportList.getTabledata();
    },
    // 产品批次表
    handleCurrentChange(val) {
      this.productSearchForm.outBillCode = val.out_bill_code;
      this.productSearchForm.productCode = val.product_code;
      this.productSearchForm.pageIndex = 1;
      this.fetchProductTableData();
    },
    fetchProductTableData() {
      outbillorderproductsbatchlist(this.productSearchForm).then(response => {
        this.productData = response.data.list;
        this.productPageTotal = response.data.totalCount;
      })
    },
    handleProductCurrentChange(val) {
      this.fetchProductTableData();
    },
    handleProductSizeChange(val) {
      this.fetchProductTableData();
    },
    //完成出库操作
    updateoutstatus(outbillcode) {
      this.$confirm("此操作将该出库单完成出库, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          updateoutstatus({
            outbillcode: outbillcode
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "出库成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "出库失败!请检查字段"
              });
            }
          });
        })
    },
    // 新增
    addorder() {
      this.$refs.editorder.title = '新增出库单';
      this.$refs.editorder.resetForm('form');
      this.$refs.editorder.tablelist = [];
      this.$refs.editorder.show = true;
    },
    // 下载出库单
    getoutbilldata(outbillcode) {
      this.$refs.editorder.title = '修改出库单';
      donloadoutbillorder({
        outbillcode: outbillcode
      }).then(response => {
        if (response.status_code == 200) {
          document.getElementById("A1").scrollIntoView({
            block: "start",
            inline: "nearest",
            behavior: "smooth"
          });
          this.$refs.editorder.form = response.data;
          this.$refs.editorder.getkeypagelist(response.data.dealerName);
          this.$refs.editorder.changedealer(response.data.dealerCode);
          this.$refs.editorder.getcity(response.data.provinceId);
          this.$refs.editorder.getdistrict(response.data.cityId);
          this.$refs.editorder.tablelist = response.data.orderProductsEntityList;
          this.$refs.editorder.show = true;
        }
      });
    },
    // //请求部门树结构
    getdeparttree() {
      departtree({ departType: 3 }).then(response => {
        this.departtree = this.getTreeData(response.data);
      });
    },
    getTreeData(data) {
      // 去除树空子集
      for (var i = 0; i < data.length; i++) {
        if (data[i].listSubWareHouses.length < 1) {
          data[i].listSubWareHouses = undefined;
        } else {
          this.getTreeData(data[i].listSubWareHouses);
        }
      }
      return data;
    },
    // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      selectoutbillorder(obj).then(response => {
        this.tableData = response.data.list;
        // for (let i = 0; i < this.tableData.length; i++) {
        //   switch (this.tableData[i].extension_field1) {
        //     case '0':
        //       this.tableData[i].extension_field1 = null;
        //       break
        //     case '15':
        //       this.tableData[i].extension_field1 = "普通销售";
        //       break;
        //     case '16':
        //       this.tableData[i].extension_field1 = "销售退货";
        //       break;
        //     case '17':
        //       this.tableData[i].extension_field1 = "其他出库单";
        //       break;
        //   }
        // }
        this.packdate(this.tableData);
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        this.listLoading = false;
      });
    },
    // 拼装表格数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].out_bill_time = this.$parseTime(obj[i].out_bill_time); // 出库时间

        switch (obj[i].status) {
          case 0:
            obj[i].status = "未发货";
            break;
          case 1:
            obj[i].status = "已发货";
            break;
          case 2:
            obj[i].status = "已签收";
            break;
          case 3:
            obj[i].status = "已下载";
            break;
          case 4:
            obj[i].status = "扫码中";
            break;
          case 5:
            obj[i].status = "已取消";
            break;
          case 6:
            obj[i].status = "已确认数量";
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        status: this.searchform.status,
        batch_no: this.searchform.batch_no,
        out_bill_code: this.searchform.out_bill_code,
        dealer_name: this.searchform.dealer_name,
        freight_bill_code: this.searchform.freight_bill_code,
        sout_bill_date:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        eout_bill_date:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        start_time:
          this.searchform.datelist1 == null ? null : this.searchform.datelist1[0],
        end_time:
          this.searchform.datelist1 == null ? null : this.searchform.datelist1[1],
        from_warehouse_code: this.searchform.from_warehouse_code,
        product_code: this.searchform.product_code,
        pageSize: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        status: this.searchform.status,
        batch_no: this.searchform.batch_no,
        out_bill_code: this.searchform.out_bill_code,
        dealer_name: this.searchform.dealer_name,
        freight_bill_code: this.searchform.freight_bill_code,
        sout_bill_date:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        eout_bill_date:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        start_time:
          this.searchform.datelist1 == null ? null : this.searchform.datelist1[0],
        end_time:
          this.searchform.datelist1 == null ? null : this.searchform.datelist1[1],
        from_warehouse_code: this.searchform.from_warehouse_code,
        product_code: this.searchform.product_code,
        currPage: this.searchform.currPage,
        pageSize: this.searchform.pageSize
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //删除按钮事件
    deletedate(outbillcode) {
      this.$confirm("此操作将永久删除该出库单信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteoutbillorder({
            outbillcode: outbillcode
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 载入提示
    open() {
      const h = this.$createElement;
      this.$notify({
        title: "页面提示",
        message: h("i", "数据量较大，请输入搜索条件进行筛选")
      });
    },
    //导出表格事件
    handleDownload() {
      if (
        this.searchform.batch_no ||
        this.searchform.out_bill_code ||
        this.searchform.dealer_name ||
        this.searchform.freight_bill_code ||
        this.searchform.from_warehouse_code ||
        this.searchform.product_code ||
        this.searchform.datelist
      ) {
        this.downloadLoading = true;
        let obj = Object.assign({}, this.searchform);
        obj.pageSize = this.total_count;
        obj.page_index = 1;
        delete obj.datelist;
        delete obj.datelist1;
        obj.sout_bill_date = this.searchform.datelist == null ? null : this.searchform.datelist[0];
        obj.eout_bill_date = this.searchform.datelist == null ? null : this.searchform.datelist[1];
        obj.start_time =
          this.searchform.datelist1 == null ? null : this.searchform.datelist1[0],
          obj.end_time =
          this.searchform.datelist1 == null ? null : this.searchform.datelist1[1],
          selectoutbillorder(obj).then(response => {
            this.tableDataDownload = response.data.list;
            this.packdate(this.tableDataDownload);
            import("@/vendor/Export2Excel").then(excel => {
              const tHeader = [
                "运单号",
                "出库单号",
                "出库时间",
                "发货仓库编码",
                "发货仓库",
                "客户编码",
                "客户名称",
                "客户地址",
                "产品编码",
                "产品名称",
                "单位",
                "计划出库数量",
                "箱码数量",
                "扫码数量",
                "发货状态"
              ];
              const filterVal = [
                "freight_bill_code",
                "out_bill_code",
                "out_bill_time",
                "from_warehouse_code",
                "from_warehouse",
                "dealer_code",
                "dealer_name",
                "address",
                "product_code",
                "product_name",
                "min_pack_unit",
                "plan_quantity",
                "confirm_quantity",
                "qty2",
                "status"
              ];
              const list = this.tableDataDownload;
              const data = this.formatJson(filterVal, list);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: '出库单列表',
                autoWidth: true,
                bookType: 'xlsx'
              });
              this.downloadLoading = false;
            });
          }); // hear
      } else {
        this.$message({
          type: "warning",
          message: "请输入导出条件"
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    dataURLtoBlob(dataurl) {
      //生产工单导出
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    exportdate(row) {
      downloadoutbill({
        outbill_code: row.out_bill_code,
        batch_no: row.batch_no,
        product_code: row.product_code
      })
        .then(response => {
          const content = this.dataURLtoBlob(response.data);
          const blob = new Blob([content], { type: "application/zip" });
          const fileName = response.message;
          if ("download" in document.createElement("a")) {
            // IE下载
            const elink = document.createElement("a");
            elink.download = "生产工单";
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            // 谷歌火狐下载
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
            if (window.navigator.msSaveBlob) {
              // ie下载
              console.log(window.navigator.msSaveBlob);
              try {
                window.navigator.msSaveBlob(blob, fileName);
              } catch (e) {
                console.log(e);
              }
            }
          } else {
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    },
    //下载导入模板
    clickDownloadExcel() {
      window.open("/ts/tpls/outbillorder_import.xls", '_blank')
    },
    //导入
    clickImportExcel() {
      this.importExcel.dialogVisible = true;
    },
    beforeUpload(file) {
      const fileExtension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);
      if (fileExtension != "xls" && fileExtension != "xlsx") {
        this.$message.error('只能上传xls或xlsx文件');
        return false;
      }
      this.importExcel.loading = true
    },
    handleSuccess(response, file, fileList) {
      this.importExcel.loading = false
      console.log("handleSuccess", response, file, fileList)
      if (response.status_code == 200) {
        this.$message({
          message: response.data,
          type: 'success'
        });
      } else {
        this.$message.error(response.message);
        return false;
      }
    },
    handleError(err, file, fileList) {
      this.importExcel.loading = false
      console.log(err, file, fileList)
    },
    handlePrinter(row) {
      this.$refs.print.getData(row)
    },
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
};
</script>
